import { gql } from "@apollo/client"

export const FeaturedCompanyFragment = gql`
    fragment FeaturedCompanyFragment_company on CompanyType {
        id
        image
        name
        website
    }
`
